module.exports = __webpack_public_path__ + "static/media/激光切割触摸台灯.e380c7a7.png";